import { render, staticRenderFns } from "./WriteText.vue?vue&type=template&id=58ec602e&scoped=true&"
import script from "./WriteText.vue?vue&type=script&lang=ts&"
export * from "./WriteText.vue?vue&type=script&lang=ts&"
import style0 from "./WriteText.vue?vue&type=style&index=0&id=58ec602e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec602e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VContainer,VIcon,VImg,VRow,VTextarea})
